module.exports = __webpack_public_path__ + "img/coin_nickels.251b3243.svg";